function isBannerRecommendation(recommendation) {
  return recommendation.recommendationType === "banner";
}
export {
  isBannerRecommendation
};
//# sourceMappingURL=guards.js.map
